module.exports = __webpack_public_path__ + "static/media/icon_coupon_b.62ece1d0.svg";